import "./cancel-dispatch-modal.css";

import { SvgIcon } from "@tql/ui-components-react/kendo/common";
import { check } from "@tql/ui-components-react/untitled/icons";

import { TraxModal } from "~/shared/components/trax-modal/trax-modal.tsx";

export const CancelDispatchModal = ({
	onClose,
	isOpen,
}: {
	onClose: () => void;
	isOpen: boolean;
}) => {
	if (!isOpen) {
		return null;
	}

	return (
		<TraxModal
			className={"cancel-dispatch-modal"}
			confirmText={"Ok"}
			onClose={onClose}
			onConfirm={onClose}
			showCancelButton={false}
			title={`Cancel Dispatch`}
			type={"confirmation"}
			width={280}
		>
			<div className={"cancel-dispatch-message"}>
				<SvgIcon className={"cancel-dispatch-icon"} icon={check} />
				Dispatch canceled successfully.
			</div>
		</TraxModal>
	);
};
